const urlMatchMap = {
  youtube: /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(\S+)/g,
  vimeo: /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(\S+)/g,
  twitch: /(?:http?s?:\/\/)?(?:www\.)?(?:twitch\.tv)\/?(\S+)/g,
};

const convertYoutube = (input, pattern) => {
  const inputStr = input.split('&')[0];
  const replacement = 'https://www.youtube.com/embed/$1';
  let embedUrl = inputStr.replace(pattern, replacement);
  // For start time, turn get param & into ?
  return embedUrl.replace('&amp;t=', '?t=');
};

const convertVimeo = (input, pattern) => {
  const replacement = '//player.vimeo.com/video/$1';
  let embedUrl = input.replace(pattern, replacement);
  return embedUrl;
};

const convertTwitch = (input, pattern) => {
  let replacement = 'https://player.twitch.tv/?channel=$1&parent=whatsform.com&!autoplay';
  if (input.includes('clips.twitch.tv')) {
    replacement = 'https://clips.twitch.tv/embed?clip=$1&parent=www.example.com&!autoplay';
  }
  const embedUrl = input.replace(pattern, replacement);
  return embedUrl;
};

export const embedUrlGenerator = (inputUrl) => {
  if (urlMatchMap['youtube'].test(inputUrl))
    return convertYoutube(inputUrl, urlMatchMap['youtube']);
  if (urlMatchMap['vimeo'].test(inputUrl)) return convertVimeo(inputUrl, urlMatchMap['vimeo']);
  // if (urlMatchMap['twitch'].test(inputUrl)) return convertTwitch(inputUrl, urlMatchMap['twitch']);
  return inputUrl;
};
